import { useState } from "react";
import { Divider } from "../../../../components";
import { ArrowDownIcon, WarningIcon } from "../../../../assets/icons";
import { getVendorNature } from "../../../LoanApplicationSteps/VendorInformation/utils";
import { LoanProductType, Vendor } from "../../../../hooks/api/types";
import PendingLoanVendorsSection from "../PendingLoanVendorsSection";

interface ActionRequiredSectionProps {
  vendors: Array<Vendor>;
  loanApplication: any;
  loanType: LoanProductType;
  onSuccess: () => void;
}

const ActionRequiredSection = ({
  vendors,
  loanApplication,
  loanType,
  onSuccess,
}: ActionRequiredSectionProps) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
  const vendorNature = getVendorNature(loanType);

  return (
    <div className="cx-bg-white cx-rounded-lg cx-shadow-sm cx-border cx-border-neutral-light cx-overflow-hidden cx-mb-6">
      <div
        className="cx-px-4 sm:cx-px-6 cx-py-3 cx-bg-gray-50 cx-border-b cx-cursor-pointer hover:cx-bg-gray-100 cx-transition-colors"
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <div className="cx-flex cx-items-start sm:cx-items-center cx-gap-2 cx-justify-between">
          <div className="cx-flex cx-items-start sm:cx-items-center cx-gap-2 cx-min-w-0 cx-flex-wrap">
            <span className="cx-shrink-0 cx-flex cx-items-center cx-h-5">
              <WarningIcon
                className="cx-text-[#DA1E28]"
                width={18}
                height={18}
              />
            </span>
            <span className="cx-text-[#A2191F] cx-font-medium">
              {vendors.length} {vendors.length === 1 ? "Action" : "Actions"}{" "}
              Required:
            </span>{" "}
            Please complete to proceed
          </div>
          <ArrowDownIcon className="cx-text-text-secondary cx-w-3 cx-h-3 cx-shrink-0 cx-mt-1.5 sm:cx-mt-0" />
        </div>
      </div>

      {!isCollapsed && (
        <div className="cx-p-4 sm:cx-p-6">
          <div className="cx-flex cx-flex-col cx-gap-3 cx-p-4 cx-bg-white cx-border cx-border-neutral-light cx-rounded-lg">
            <div className="cx-flex cx-items-start cx-gap-3">
              <WarningIcon
                className="cx-text-yellow-600 cx-flex-shrink-0 cx-mt-0.5"
                width={16}
                height={16}
              />
              <div className="cx-text-sm cx-text-text-primary">
                Some of your {vendorNature}s are pending. Open the{" "}
                {vendorNature}s and take necessary action
              </div>
            </div>
            <Divider />
            <PendingLoanVendorsSection
              loanApplication={loanApplication}
              vendors={vendors}
              onSuccess={onSuccess}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionRequiredSection;
